import React from "react";
import SupportEmail from "../components/SupportEmail";

const About = () => {
  return (
    <>
      <div className="about-container">
        <h1>About Us</h1>
        <p>
        <strong>Omega Void&reg; is a privacy-first messaging platform built for people who want to share
information without attaching it to their real-world identity. </strong>No names, no emails, no
public profiles — just a randomly generated Login ID and simple message links. Messages
are designed to be direct, temporary, and free from the noise of feeds, followers, or data
harvesting.
<br></br>
Omega Void is engineered to minimize personal data collection while keeping the platform
stable and secure. We do not sell user data. Limited technical safeguards, including
device-based abuse prevention measures, are used strictly to protect the system from spam
and automated attacks — not for advertising or cross-site tracking. Our goal is
straightforward: reduce unnecessary data collection and give people a cleaner, calmer way to
communicate.
<br></br>
<br></br>
Omega Void is a technology product of <strong>Omega Ops Tech</strong>, a registered business name of Omega Ops Cybernetics Defence Corp.
    </p>
      </div>
      <SupportEmail />
    </>
  );
};

export default About;